import { Routes } from '@angular/router';

import { HomeComponent } from './home.component';
import { BookComponent } from './book/book.component';
import { CalendarComponent } from './calendar/calendar.component';
import { CommonComponent } from './common/common.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DocumentComponent } from './document/document.component';
import { EmployeeComponent } from './employee/employee.component';
import { ProviderComponent } from './provider/provider.component';
import { SalesComponent } from './sales/sales.component';

import { GeneralComponent } from './setting/general/general.component';
import { ContractComponent } from './setting/contract/contract.component';

export const HomeRoutes: Routes = [{
    path: 'home',
    component: HomeComponent,
    children: [{
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    }, {
        path: 'book',
        component: BookComponent
    }, {
        path: 'calendar',
        component: CalendarComponent
    }, {
        path: 'common',
        component: CommonComponent
    }, {
        path: 'dashboard',
        component: DashboardComponent
    }, {
        path: 'document',
        component: DocumentComponent
    }, {
        path: 'employee',
        component: EmployeeComponent
    }, {
        path: 'provider',
        component: ProviderComponent
    }, {
        path: 'sales',
        component: SalesComponent
    }, {
        path: 'setting/general',
        component: GeneralComponent
    }, {
        path: 'setting/contract',
        component: ContractComponent
    }]
}];